<template>
  <div>
    <OnboardingForm v-if="onboardingFlow" />
    <DefaultForm v-else />
  </div>
</template>

<script>
import OnboardingForm from 'components/resetPassword/OnboardingForm'
import DefaultForm from 'components/resetPassword/DefaultForm'

export default {
  name: 'ResetPassword',
  components: {
    OnboardingForm,
    DefaultForm
  },
  computed: {
    onboardingFlow () {
      return this.$route.query.onboarding
    }
  }
}
</script>
